<div class="row no-gutters">
  @for (device of devices; track device; let i = $index) {
    <div class="col-12 col-sm-4 px-2">
      <div class="container-fluid mb-3 store-device-card" [class.buddy-device-card]="isBuddyDevice">
        <div class="row header g-0 px-2 px-sm-4">
          <label class="col-1 col-sm-2 d-flex align-items-center font-weight-bold device-no pr-0 pr-sm-3">
            {{ getDeviceNo | pureFn: i + 1 }}
          </label>
          <div class="col-10 col-sm-9 d-flex justify-content-end">
            <ng-container *appHasPermission="['store_eq']">
              @if (
                (!device.deviceId || device.status === posStatus.DEACTIVATED) &&
                (storeStatus$ | async) !== StoreStatus.INACTIVE
              ) {
                <button type="button" class="btn btn-standard" (click)="onRegister(i + 1)">
                  <em class="icon-gen-user-pass"></em>
                  Generate Registration Code
                </button>
              }
            </ng-container>
          </div>
          <div class="col-1 p-0 justify-content-end">
            <a
              href="javascript:void(0)"
              class="btn-more float-right"
              [popover]="moreTemplate"
              placement="bottom right"
              [adaptivePosition]="false"
              [outsideClick]="true"
            >
              <em class="icon-more"></em>
            </a>
            <ng-template #moreTemplate>
              <ng-container *appHasPermission="['store_eq']">
                @if (device.status === posStatus.WAITING) {
                  <button type="button" class="btn btn-link" (click)="regenerateCode(device)">
                    <em class="icon-reset-pin"></em>Regenerate Code
                  </button>
                }
                @if (device.status === posStatus.ACTIVATED) {
                  @if (!isBuddyDevice) {
                    <button type="button" class="btn btn-link" (click)="onUpdateRegisterPOS(device)">
                      <em class="icon-edit"></em>Edit
                    </button>
                  }
                  <button type="button" class="btn btn-link" (click)="onDeactivate(i + 1)">
                    <em class="icon-deactivate"></em>Deactivate
                  </button>
                }
              </ng-container>
              <button type="button" class="btn btn-link" (click)="showHistory(i + 1)">
                <em class="icon-history"></em>Previous Setting
              </button>
            </ng-template>
          </div>
        </div>
        <div class="body px-2 px-sm-4">
          <div class="row">
            <div class="col-6">
              <span class="info-text-label">Device ID:</span>
            </div>
            <div class="col-6 pr-0">
              <span class="info-text-value text-break">{{
                dashDisplay | pureFn: device.deviceId : device.status
              }}</span>
            </div>
          </div>
          @if (!isBuddyDevice) {
            <div class="row mt-1">
              <div class="col-6">
                <span class="info-text-label">RD Registered No.:</span>
              </div>
              <div class="col-6 pr-0">
                <span class="info-text-value text-break">{{
                  dashDisplay | pureFn: device?.registeredNo : device.status
                }}</span>
              </div>
            </div>
          }
          <div class="row mt-1">
            <div class="col-6">
              <span class="info-text-label">Serial No.:</span>
            </div>
            <div class="col-6 pr-0">
              <span class="info-text-value text-break">{{
                dashDisplay | pureFn: (device?.serialNo | dashDisplay) : device.status
              }}</span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6">
              <span class="info-text-label">Effective Date:</span>
            </div>
            <div class="col-6 pr-0">
              <span class="info-text-value">{{
                dashDisplay
                  | pureFn: (device?.effectiveDate | dashDisplay | amFromUtc | amLocal | dateDisplay) : device.status
              }}</span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6">
              <span class="info-text-label">Last Updated:</span>
            </div>
            <div class="col-6 pr-0">
              <span class="info-text-value">{{
                dashDisplay
                  | pureFn: (device?.registerDate | dashDisplay | amFromUtc | amLocal | dateDisplay) : device.status
              }}</span>
            </div>
          </div>
          <div class="row mt-1">
            <div class="col-6">
              <span class="info-text-label">Status:</span>
            </div>
            <div class="col-6 pr-0">
              @if (device.status) {
                <span class="info-text-value pos-status" [ngClass]="getColorStatus | pureFn: device.status">
                  {{ dashDisplay | pureFn: ('POS_STATUS.' + device.status | translate) : device.status }}
                </span>
              } @else {
                <span>-</span>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <ng-container *appHasPermission="['store_eq']">
    @if (devices?.length < maxDevices && showAddDevice && (storeStatus$ | async) !== StoreStatus.INACTIVE) {
      <div class="col-12 col-sm-4 px-2">
        <div class="container-fluid mb-3 store-device-card" [class.buddy-device-card]="isBuddyDevice">
          <div class="add-device" (click)="onAddDevice()">
            + <u class="ml-1">{{ labelAddDevice }}</u>
          </div>
        </div>
      </div>
    }
  </ng-container>
</div>

<app-modal-template-container></app-modal-template-container>
